import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { CharterSubtype } from "__generated__/enums";
import { SelectProps } from "@cofano/cck/Select/Select";
import { useStoreState } from "ezStore";
import { getApplicableCharterSubtypes } from "utils/charterUtils";
import { getCharterSubtypeColor } from "view/charters/utils/CharterUtils";

const CharterSubtypeSelect = <Multiple extends boolean = false, >({
	label,
	value,
	onChange,
	disabled,
	multiple,
	disableClear,
	customCharterSubtypes = [ CharterSubtype.Spot, CharterSubtype.Time, CharterSubtype.Contract ],
}: Omit<SelectProps<CharterSubtype, Multiple>, "fetchOptions"> & { disableClear?: boolean, customCharterSubtypes?: CharterSubtype[] }) => {
	const session = useStoreState(store => store.session);

	return (
		<Select
			label={label}
			fetchOptions={getApplicableCharterSubtypes(session, customCharterSubtypes)}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			value={value}
			onChange={onChange}
			disabled={disabled}
			multiple={multiple}
			clearable={!disableClear}
			getOptionColor={getCharterSubtypeColor}
			disableSearch />
	);
};

export default CharterSubtypeSelect;
